import { useEffect, useState } from 'react';
import { ArrowLeft, ArrowRight, Quote, Star } from 'lucide-react';
import SectionHeading from './SectionHeading.jsx';
import { testimonials } from '../data/siteData.js';
import useReducedMotion from '../hooks/useReducedMotion.js';

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const reducedMotion = useReducedMotion();

  useEffect(() => {
    if (reducedMotion) return undefined;

    const timer = window.setInterval(() => {
      setActiveIndex((current) => (current + 1) % testimonials.length);
    }, 6500);

    return () => window.clearInterval(timer);
  }, [reducedMotion]);

  const previous = () => {
    setActiveIndex((current) => (current - 1 + testimonials.length) % testimonials.length);
  };

  const next = () => {
    setActiveIndex((current) => (current + 1) % testimonials.length);
  };

  const testimonial = testimonials[activeIndex];

  return (
    <section className="section testimonials-section">
      <div className="container testimonials-layout">
        <div>
          <SectionHeading
            eyebrow="Visszajelzések"
            title="A legjobb bizonyíték az, amit a kliensek éreznek."
            text="Ezek jelenleg mintaszövegek a dizájn bemutatásához. Élesítéskor csak valódi, ellenőrizhető értékeléseket használj."
          />

          <div className="testimonial-controls">
            <button type="button" onClick={previous} aria-label="Előző vélemény">
              <ArrowLeft size={20} />
            </button>
            <div className="testimonial-progress" aria-label={`${activeIndex + 1} / ${testimonials.length}`}>
              {testimonials.map((item, index) => (
                <button
                  type="button"
                  key={item.name}
                  className={index === activeIndex ? 'active' : ''}
                  onClick={() => setActiveIndex(index)}
                  aria-label={`${index + 1}. vélemény megnyitása`}
                />
              ))}
            </div>
            <button type="button" onClick={next} aria-label="Következő vélemény">
              <ArrowRight size={20} />
            </button>
          </div>
        </div>

        <article className="testimonial-card" key={testimonial.name}>
          <Quote className="testimonial-quote-icon" size={54} />
          <div className="stars" aria-label={`${testimonial.rating} csillagos értékelés`}>
            {Array.from({ length: testimonial.rating }).map((_, index) => (
              <Star key={index} size={19} fill="currentColor" />
            ))}
          </div>
          <blockquote>„{testimonial.text}”</blockquote>
          <div className="testimonial-person">
            <div className="testimonial-avatar">{testimonial.name.charAt(0)}</div>
            <div>
              <strong>{testimonial.name}</strong>
              <span>{testimonial.role}</span>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
}
